<template>
  <ForceNewsBlockWrapper :requireCharacters="requireCharacters"
                         :titleLabel="$t('force_news.fib.label')"
                         :parentScreen="parentScreen">
    <div class="form-group row">
      <label class="col-md-3">{{ $t('profile.label.financial_assets') }}</label>
      <div class="col-md-6">
        <select
            class="form-control"
            v-model="$v.input['amsCustomerDetail.financialAssets'].$model"
            @change="onChangeFinancialAssets()"
        >
          <option v-for="item in LIST_FINAL_ASSETS" :key="item.key" :value="item.key">
            {{ $t(item.value) }}
          </option>
        </select>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-md-3">{{ $t('profile.label.investment_amount') }}</label>
      <div class="col-md-6">
        <select
            class="form-control"
            v-model="$v.input['amsCustomerDetail.investmentAmount'].$model"
            @change="onChangeInvestmentAmount()"
        >
          <option v-for="item in investmentAmountValues" :key="item.key" :value="item.key">
            {{ $t(item.value) }}
          </option>
        </select>
        <div v-if="!$v.input['amsCustomerDetail.investmentAmount'].validForBoHedgeAmount" class="checkbox error-messages ng-active">
          {{ input.errorMessageAboutBoHedgeAmount }}
        </div>
      </div>
    </div>


    <div v-if="this.isBoServiceOpenCompleted" class="form-group row">
      <label class="col-md-3">{{ $t('profile.label.bo_loss_maximum_amount') }}</label>
      <div class="col-md-6">
        <div class="input-group">
          <template>
            <input type="text"
                   class="form-control bo-loss-max-amount"
                   v-model="$v.input['amsCustomerDetail.boLossMaxAmount'].$model"
                   name="boLossMaxAmount"
                   @keyup="amountKeyUp()"
                   @keydown="amountKeyDown($event)"
                   v-convert-fullwidth-to-halfwidth
                   v-numbers-only
            >
            <div class="input-group-append ">
              <span class="input-group-text currency-addon bg-light-gray">
                {{ $t('profile.label.max_loss_amount.unit') }}
              </span>
            </div>
          </template>
        </div>
        <div v-if="$v.input['amsCustomerDetail.boLossMaxAmount'].$anyError" class="error-messages ng-active">
          <div v-if="!$v.input['amsCustomerDetail.boLossMaxAmount'].required">
            <div>{{ $t('MSG_TRS_NAF_0004_param', {param1: $t('profile.label.bo_loss_maximum_amount')}) }}</div>
          </div>
          <div
              v-if="$v.input['amsCustomerDetail.boLossMaxAmount'].required && !$v.input['amsCustomerDetail.boLossMaxAmount'].validBoMaxLoss">
            <div>{{ input.messageBoMaxLossAmount }}</div>
          </div>
        </div>
        <p class="form-text text-muted">{{ $t('profile.message.below_bo_max_loss_amount') }}</p>
      </div>
    </div>
  </ForceNewsBlockWrapper>
</template>

<script>
import formMixin from '@/common/mixins/form';
import forceNewUtil from "@/common/mixins/forceNewUtil";
import {createNamespacedHelpers} from 'vuex';
import * as FORCE_NEWS_TYPE from '@/store/modules/force-news/type'
import ServiceUtils from "@/common/utils/ServiceUtils";
import {requiredIf} from 'vuelidate/lib/validators';
import IConstants from '@/common/constants/IConstants';

const {mapActions: mapForNewsActions} = createNamespacedHelpers("forceNews");
const {mapState: mapHeaderState} = createNamespacedHelpers('header');

const PLEASE_SELECT_VALUE = '-1';

export default {
  name: "UpdateFinancialInfo",
  props: {},
  data() {
    return {
      LIST_FINAL_ASSETS: IConstants.LIST_FINAL_ASSETS
    }
  },
  mixins: [formMixin, forceNewUtil],
  methods: {
    ...mapForNewsActions([FORCE_NEWS_TYPE.GET_VALIDATE_SELF_ASSET_AND_BO_MAX_LOSS]),

    onChangeFinancialAssets() {
      let financialAssets = this.input['amsCustomerDetail.financialAssets'];
      let investmentAmount = this.input['amsCustomerDetail.investmentAmount'];
      if (financialAssets < investmentAmount) {
        this.$v.input['amsCustomerDetail.investmentAmount'].$model = PLEASE_SELECT_VALUE;
      }
    },

    validateSelfAssetAndBoMaxLoss() {
      if (this.isBoServiceOpenCompleted) this[FORCE_NEWS_TYPE.GET_VALIDATE_SELF_ASSET_AND_BO_MAX_LOSS]({messageId: this.input.messageId,});
    },

    onChangeInvestmentAmount() {
      if (this.isBoServiceOpenCompleted) {
        this.validateSelfAssetAndBoMaxLoss();
      }
    },

    amountKeyUp() {
      if (this.input && this.input['amsCustomerDetail.boLossMaxAmount']) {
        let val = this.input['amsCustomerDetail.boLossMaxAmount'];
        this.input['amsCustomerDetail.boLossMaxAmount'] = this.$options.filters.formatAmount(val, 7)
      }
    },

    amountKeyDown(e) {
      if (this.input) {
        let charCode = (e.which) ? e.which : e.keyCode;
        let val = this.input['amsCustomerDetail.boLossMaxAmount'];
        if (val && val.length >= 10 && !(charCode == 37 || charCode == 38 || charCode == 39 || charCode == 40 || charCode == 8 || charCode == 46 || charCode == 116)) {
          e.preventDefault();
          return false;
        }
      }
    },

  },
  validations() {
    return {
      input: {
        'amsCustomerDetail.financialAssets': {
          validFinancialAssetsSelected: function () {
            return this.input['amsCustomerDetail.financialAssets'] != PLEASE_SELECT_VALUE;
          }
        },
        'amsCustomerDetail.investmentAmount': {
          validInvestmentAmountSelected: function () {
            return this.input['amsCustomerDetail.investmentAmount'] != PLEASE_SELECT_VALUE;
          },
          validForBoMaxLoss: function () {
            if (!this.isBoServiceOpenCompleted) {
              return true;
            }
            return !this.input.invalidForBoMaxLoss
          },
          validForBoHedgeAmount: function () {
            if (!this.isBoServiceOpenCompleted) {
              return true;
            }
            return !this.input.invalidForBoHedgeAmount;
          },
        },
        'amsCustomerDetail.boLossMaxAmount': {
          required: requiredIf(function () {
            return this.isBoServiceOpenCompleted;
          }),
          validBoMaxLoss: function () {
            return this.isBoServiceOpenCompleted ? this.input.validBoMaxLoss : true;
          }
        }
      }
    }
  },
  computed: {
    ...mapHeaderState({
      corpType: state => state.headerInfo.corporationType,
      boServiceStatus: state => state.headerInfo.boServiceStatus,
    }),

    isCustomerIndividual: function () {
      return this.corpType === 0;
    },

    investmentAmountValues() {
      const financialAssets = this.input['amsCustomerDetail.financialAssets'];
      return this.calculateInvestmentAmountValues(financialAssets);
    },

    isBoServiceOpenCompleted() {
      return ServiceUtils.isServiceOpenCompleted(this.boServiceStatus);
    },

    boLossMaxAmount() {
      return this.input['amsCustomerDetail.boLossMaxAmount'];
    }
  },
  watch: {
    '$v.$invalid': {
      handler() {
        this.$v.$touch();
        this.handleForceNewEvent();
      },
      deep: true
    },
    boLossMaxAmount() {
      this.validateSelfAssetAndBoMaxLoss();
    }
  }
}
</script>

<style scoped>
.bo-loss-max-amount {
    text-align:right;
    background-color: #fff !important;
}
</style>
